import React from "react";

const SelectOptMsg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
      <g id="freepik--background-complete--inject-6">
        <rect y="382.4" width="500" height="0.25" fill="#e6e6e6"></rect>
        <rect
          x="51.65"
          y="394.26"
          width="54.34"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="230.54"
          y="388.83"
          width="20.46"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="151.34"
          y="388.83"
          width="29.94"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="365.57"
          y="391.71"
          width="63.34"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="224.93"
          y="391.71"
          width="14.29"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="115.67"
          y="394.26"
          width="13.33"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="437.08"
          y="391.71"
          width="8.51"
          height="0.25"
          fill="#e6e6e6"
        ></rect>
        <path
          d="M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z"
          fill="#e6e6e6"
        ></path>
        <path
          d="M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z"
          fill="#e6e6e6"
        ></path>
        <rect
          x="189.27"
          y="85.56"
          width="222.89"
          height="129.56"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="192.28"
          y="85.56"
          width="222.89"
          height="129.56"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="245.03"
          y="44.31"
          width="117.4"
          height="212.07"
          transform="translate(454.07 -153.39) rotate(90)"
          fill="#fff"
        ></rect>
        <rect
          x="349.92"
          y="149.2"
          width="117.4"
          height="2.28"
          transform="translate(558.97 -258.28) rotate(90)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="194.52"
          y="172.55"
          width="218.42"
          height="8.16"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="216.4"
          y="296.11"
          width="36.6"
          height="81.15"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="223.42"
          y="377.26"
          width="161.12"
          height="5.14"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="253"
          y="296.11"
          width="138.58"
          height="81.15"
          transform="translate(644.57 673.37) rotate(180)"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="267.38"
          y="306.1"
          width="109.8"
          height="26.61"
          transform="translate(644.57 638.81) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="267.38"
          y="340.66"
          width="109.8"
          height="26.61"
          transform="translate(644.57 707.92) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="304.22"
          y="317.58"
          width="36.14"
          height="3.65"
          rx="1.61"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="304.22"
          y="352.14"
          width="36.14"
          height="3.65"
          rx="1.61"
          fill="#f5f5f5"
        ></rect>
        <polygon
          points="143.38 382.4 65.41 382.4 54.66 123.73 132.63 123.73 143.38 382.4"
          fill="#e6e6e6"
        ></polygon>
        <polygon
          points="154.67 382.4 67.41 382.4 56.66 123.73 143.92 123.73 154.67 382.4"
          fill="#f5f5f5"
        ></polygon>
        <polygon
          points="76.03 373.4 66.03 132.73 135.29 132.73 145.3 373.4 76.03 373.4"
          fill="#fff"
        ></polygon>
        <path
          d="M284.93,283.59c1-27.32,2-65.17-.11-78.87l-3.45-2.67s.75,2.55,1.15,44.41.89,30.91.47,37.13Z"
          fill="#e0e0e0"
        ></path>
        <path
          d="M291.35,193.09c6.38-8.65,19.81-14.8,33.72-14.77,5.46,0-16.26,10.06-25.05,21.15-6.83,8.61-14.36,23.1-16.82,31.14C284.38,213.69,285,201.73,291.35,193.09Z"
          fill="#e0e0e0"
        ></path>
        <path
          d="M278.55,215.62c-5.86-9-18.91-15.93-32.79-16.71-5.45-.31,15.64,11,23.77,22.57,6.31,9,13,23.9,15,32.08C284.31,236.6,284.42,224.63,278.55,215.62Z"
          fill="#e0e0e0"
        ></path>
        <path
          d="M281.17,178.65c-5.34-10.5-17.8-20.63-31.35-24.75-5.33-1.62,16.74,16.86,23.05,31,4.9,11,10.84,24.82,12.4,33.55C285.85,201.23,286.5,189.16,281.17,178.65Z"
          fill="#e0e0e0"
        ></path>
        <path
          d="M283.64,296.11h0a12.7,12.7,0,0,0,12.68-12l1.12-19.5h-27.6l1.13,19.5A12.69,12.69,0,0,0,283.64,296.11Z"
          fill="#f0f0f0"
        ></path>
        <polygon
          points="268.06 269.06 299.23 269.06 300.12 260.97 267.16 260.97 268.06 269.06"
          fill="#ebebeb"
        ></polygon>
        <rect
          x="400.58"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(821.79 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="390.34"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="369.7"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(760.04 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="359.47"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="338.83"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(698.3 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="328.6"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="307.96"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(636.55 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="297.72"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="277.08"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(574.81 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="266.85"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="246.21"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(513.06 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="235.98"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="215.34"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(451.32 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
        <rect
          x="205.11"
          y="79.17"
          width="10.23"
          height="51.5"
          fill="#f5f5f5"
        ></rect>
        <rect
          x="184.46"
          y="79.17"
          width="20.64"
          height="56"
          transform="translate(389.57 214.33) rotate(180)"
          fill="#e6e6e6"
        ></rect>
      </g>
      <g id="freepik--Shadow--inject-6">
        <ellipse
          cx="250"
          cy="416.24"
          rx="193.89"
          ry="11.32"
          fill="#f5f5f5"
        ></ellipse>
      </g>
      <g id="freepik--Character--inject-6">
        <polygon
          points="352.42 219.53 356.67 226.03 362.99 224.72 358.22 216.64 352.42 219.53"
          fill="#9f5b53"
        ></polygon>
        <path
          d="M364.47,163.82c.9,1.09,1.65,2.06,2.42,3.12s1.51,2.08,2.24,3.14c1.46,2.11,2.85,4.28,4.15,6.51s2.56,4.51,3.66,6.9c.59,1.17,1.09,2.41,1.63,3.62s1,2.48,1.39,3.79l.32,1,.16.49c.09.29.18.6.24.89a11.4,11.4,0,0,1,.22,3.16,18.1,18.1,0,0,1-1.07,4.85,39,39,0,0,1-3.74,7.42,73.31,73.31,0,0,1-9.72,12L362,217.29a142.33,142.33,0,0,0,6.58-12.64,35.39,35.39,0,0,0,2.17-6.13,9,9,0,0,0,.27-2.42,1.22,1.22,0,0,0-.11-.5s0,0,0,0l-.16-.38-.33-.76a86,86,0,0,0-6.6-12.11c-1.26-2-2.59-3.93-3.93-5.88s-2.8-3.9-4.12-5.67Z"
          fill="#9f5b53"
        ></path>
        <path
          d="M362,158.9c6.89,1.58,14.79,20.35,14.79,20.35L363,188.73a116.61,116.61,0,0,1-9.14-15.53C349.77,164.61,355,157.29,362,158.9Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M362,158.9c6.89,1.58,14.79,20.35,14.79,20.35L363,188.73a116.61,116.61,0,0,1-9.14-15.53C349.77,164.61,355,157.29,362,158.9Z"
          fill="#fff"
          opacity="0.8"
        ></path>
        <path
          d="M357.1,170.87l6.54,17.41-.65.45s-2.83-4-5.89-9.33Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M357.1,170.87l6.54,17.41-.65.45s-2.83-4-5.89-9.33Z"
          fill="#fff"
          opacity="0.6000000000000001"
        ></path>
        <polygon
          points="339.64 409.64 332.29 409.64 331.56 392.63 338.91 392.63 339.64 409.64"
          fill="#9f5b53"
        ></polygon>
        <polygon
          points="383.75 409.64 376.4 409.64 372.71 392.63 380.05 392.63 383.75 409.64"
          fill="#9f5b53"
        ></polygon>
        <polygon
          points="331.56 392.64 331.94 401.4 339.29 401.4 338.91 392.64 331.56 392.64"
          fill="#8a4743"
        ></polygon>
        <polygon
          points="380.06 392.64 372.71 392.64 374.61 401.4 381.96 401.4 380.06 392.64"
          fill="#8a4743"
        ></polygon>
        <path
          d="M334.38,222.78s8.34,56.14,12.91,77.17c5,23,23.9,99.76,23.9,99.76h13.46S372.19,324.84,369.33,302c-3.1-24.75-9.59-79.26-9.59-79.26Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M334.38,222.78s8.34,56.14,12.91,77.17c5,23,23.9,99.76,23.9,99.76h13.46S372.19,324.84,369.33,302c-3.1-24.75-9.59-79.26-9.59-79.26Z"
          opacity="0.5"
        ></path>
        <path
          d="M339.65,242.78c9.64,1.89,8.62,37.84,7.46,56.33-2.78-13.07-6.85-38.22-9.63-56.07A3.29,3.29,0,0,1,339.65,242.78Z"
          opacity="0.4"
        ></path>
        <path
          d="M320.44,222.78s-1,54.92-.21,77.33c.83,23.3,9,99.6,9,99.6h12.44s.46-74.94,1-97.82c.6-24.95,3.61-79.11,3.61-79.11Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M320.44,222.78s-1,54.92-.21,77.33c.83,23.3,9,99.6,9,99.6h12.44s.46-74.94,1-97.82c.6-24.95,3.61-79.11,3.61-79.11Z"
          opacity="0.5"
        ></path>
        <path
          d="M363.59,215.72l-5.37.92,4.77,8.08s3.74-1.8,4.42-5.29Z"
          fill="#9f5b53"
        ></path>
        <path
          d="M328.1,131.6c0,.59-.31,1.07-.7,1.07s-.7-.48-.7-1.07.31-1.07.7-1.07S328.1,131,328.1,131.6Z"
          fill="#263238"
        ></path>
        <path
          d="M327.84,132.67a21.33,21.33,0,0,1-2.83,5.07,3.41,3.41,0,0,0,2.83.53Z"
          fill="#892b29"
        ></path>
        <path
          d="M330.2,128.32a.31.31,0,0,1-.2-.07,2.75,2.75,0,0,0-2.48-.45.34.34,0,0,1-.44-.2.34.34,0,0,1,.19-.45,3.42,3.42,0,0,1,3.13.54.33.33,0,0,1,.08.48A.32.32,0,0,1,330.2,128.32Z"
          fill="#263238"
        ></path>
        <path
          d="M347.23,138.43c-1.06,5.38-2.11,15.22,1.65,18.81,0,0-1.47,5.45-11.46,5.45-11,0-5.24-5.45-5.24-5.45,6-1.43,5.84-5.88,4.79-10.05Z"
          fill="#9f5b53"
        ></path>
        <path
          d="M350.32,159.11c.79-1.72,1.65-3.7-.14-4.32-2-.68-12.77-1.37-16.49-.1a3.85,3.85,0,0,0-2.67,4.78Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M373.45,410a2.35,2.35,0,0,1-1.76-.48.7.7,0,0,1,0-.83.81.81,0,0,1,.54-.41c1.08-.24,3.1,1.14,3.19,1.2a.18.18,0,0,1,.07.18.16.16,0,0,1-.13.13A9.34,9.34,0,0,1,373.45,410Zm-.91-1.4-.22,0a.47.47,0,0,0-.32.24c-.16.28-.06.4,0,.44.31.42,1.81.42,2.91.24A5.74,5.74,0,0,0,372.54,408.62Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M375.33,409.82l-.08,0c-.76-.42-2.23-2-2.08-2.84a.57.57,0,0,1,.56-.46,1,1,0,0,1,.74.22c.85.7,1,2.82,1,2.91a.16.16,0,0,1-.08.16A.14.14,0,0,1,375.33,409.82Zm-1.48-3h-.08c-.23,0-.25.14-.26.18-.09.49.85,1.7,1.6,2.27a4.22,4.22,0,0,0-.86-2.3A.64.64,0,0,0,373.85,406.84Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M329.34,410c-.94,0-1.85-.13-2.16-.55a.67.67,0,0,1,0-.76.84.84,0,0,1,.55-.41c1.21-.33,3.79,1.13,3.9,1.19a.18.18,0,0,1,.08.18.16.16,0,0,1-.14.14A12.08,12.08,0,0,1,329.34,410Zm-1.17-1.42a1.15,1.15,0,0,0-.33,0,.51.51,0,0,0-.34.24c-.12.22-.08.32,0,.38.34.46,2.19.49,3.57.3A7.87,7.87,0,0,0,328.17,408.6Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M331.56,409.82l-.07,0c-.89-.39-2.64-2-2.51-2.81,0-.2.17-.44.65-.49a1.22,1.22,0,0,1,1,.3c.94.76,1.13,2.74,1.14,2.83a.17.17,0,0,1-.07.16A.17.17,0,0,1,331.56,409.82Zm-1.79-3h-.11c-.31,0-.33.16-.34.2-.08.5,1.12,1.75,2,2.29a4,4,0,0,0-1-2.26A.87.87,0,0,0,329.77,406.84Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M375.88,408.79h8.25a.65.65,0,0,1,.63.51l1.45,6.53a1.08,1.08,0,0,1-1.08,1.3c-2.88-.05-4.28-.22-7.91-.22-2.23,0-6.83.24-9.92.24s-3.48-3-2.22-3.33c5.66-1.24,7.79-2.95,9.61-4.57A1.74,1.74,0,0,1,375.88,408.79Z"
          fill="#263238"
        ></path>
        <path
          d="M332.34,408.79h8a.65.65,0,0,1,.63.51l1.45,6.53a1.07,1.07,0,0,1-1.06,1.3c-2.89-.05-7.07-.22-10.71-.22-4.25,0-7.93.24-12.92.24-3,0-3.85-3-2.59-3.33,5.75-1.26,10.44-1.39,15.41-4.45A3.36,3.36,0,0,1,332.34,408.79Z"
          fill="#263238"
        ></path>
        <path
          d="M321.85,173.93c-2.91,4.3-5.92,8.31-9.17,12.29a136.25,136.25,0,0,1-10.4,11.48l-1.44,1.36-.37.34-.25.23-.37.32a11,11,0,0,1-1.51,1,13.43,13.43,0,0,1-5.45,1.52,30.28,30.28,0,0,1-8.66-.71,65.72,65.72,0,0,1-14.85-5.22l1.83-5.2a117.1,117.1,0,0,0,14.19,1.93,25.64,25.64,0,0,0,6.27-.26,4,4,0,0,0,1.66-.64s0-.07,0-.07h0l.07-.08.3-.33,1.18-1.3c3.13-3.57,6.16-7.36,9.1-11.25s5.88-7.85,8.69-11.74Z"
          fill="#9f5b53"
        ></path>
        <path
          d="M325.24,175.08a34.86,34.86,0,0,1-7.76,16.82c-.16-3.52-.22-6.68-.21-9.51Z"
          fill="#bed3fc"
        ></path>
        <path
          d="M347.86,130.34c-.44,7.28-.33,11.56-4,15.3-5.53,5.62-14.51,2.28-16.25-5-1.56-6.54-.57-17.34,6.56-20.24A9.94,9.94,0,0,1,347.86,130.34Z"
          fill="#9f5b53"
        ></path>
        <path
          d="M333.72,125.5c.06,8.56,2.84,19.06,11.12,18.33,5.5-.48,9.68-10.51,10.25-14.76.87-6.5,1-7.74-2.66-8.49,1.6-.87,2.18-5-1.56-6-5.2-1.37-15-2.71-11.92-5.88-6.14,1.11-7.68,3.57-6.56,6.56-3.59-.28-5.8-2.16-5.69-5C320.75,112.67,316.89,126.3,333.72,125.5Z"
          fill="#263238"
        ></path>
        <path
          d="M338,132.46a8.22,8.22,0,0,1-2.78,4.5c-1.85,1.5-3.33.16-3.29-2,0-1.95,1.06-5.08,3.14-5.74S338.51,130.33,338,132.46Z"
          fill="#9f5b53"
        ></path>
        <path
          d="M358,122.07a7,7,0,0,0-6.63-.48S355.53,116,358,122.07Z"
          fill="#263238"
        ></path>
        <path
          d="M369,394.75c-.06,0,1.39,5.17,1.39,5.17h15.14l-.28-4.61Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M326.81,394.75c-.06,0,.7,5.17.7,5.17h15.14l.41-4.61Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M331.79,390.77a.12.12,0,0,1-.12-.11c-2.2-21.12-7.37-72.22-8-90.55-.67-18.71-.06-60.69.14-73.11,0-.07.06-.11.13-.12a.13.13,0,0,1,.12.12c-.2,12.42-.81,54.4-.14,73.1.65,18.33,5.82,69.41,8,90.53a.14.14,0,0,1-.12.14Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M331.79,390.77a.12.12,0,0,1-.12-.11c-2.2-21.12-7.37-72.22-8-90.55-.67-18.71-.06-60.69.14-73.11,0-.07.06-.11.13-.12a.13.13,0,0,1,.12.12c-.2,12.42-.81,54.4-.14,73.1.65,18.33,5.82,69.41,8,90.53a.14.14,0,0,1-.12.14Z"
          opacity="0.30000000000000004"
        ></path>
        <path
          d="M328.63,165.23c1,7-12.74,24.73-12.74,24.73l-13.77-9.48s3.82-9.79,10.25-16.21C319.71,157,327.57,157.66,328.63,165.23Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M328.63,165.23c1,7-12.74,24.73-12.74,24.73l-13.77-9.48s3.82-9.79,10.25-16.21C319.71,157,327.57,157.66,328.63,165.23Z"
          fill="#fff"
          opacity="0.8"
        ></path>
        <path
          d="M320.88,159.28s-7.82,8.83-.44,63.5h39.3c.27-6-3.52-35.46,2.29-63.88a102.56,102.56,0,0,0-13.15-1.66,145.27,145.27,0,0,0-16.7,0A73.5,73.5,0,0,0,320.88,159.28Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M320.88,159.28s-7.82,8.83-.44,63.5h39.3c.27-6-3.52-35.46,2.29-63.88a102.56,102.56,0,0,0-13.15-1.66,145.27,145.27,0,0,0-16.7,0A73.5,73.5,0,0,0,320.88,159.28Z"
          fill="#fff"
          opacity="0.8"
        ></path>
      </g>
      <g id="freepik--Buttons--inject-6">
        <circle
          cx="180.24"
          cy="113.47"
          r="25.67"
          transform="translate(29.67 264.11) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="180.24"
          cy="113.47"
          r="25.67"
          transform="translate(29.67 264.11) rotate(-77.21)"
          fill="#fff"
          opacity="0.2"
        ></circle>
        <path
          d="M177.59,146.75a33.24,33.24,0,0,1-29.19-23.3l.95-.3a32.25,32.25,0,0,0,28.32,22.6Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M177.59,146.75a33.24,33.24,0,0,1-29.19-23.3l.95-.3a32.25,32.25,0,0,0,28.32,22.6Z"
          fill="#fff"
          opacity="0.2"
        ></path>
        <path
          d="M149.21,104.22l-1-.28a33.38,33.38,0,0,1,42.82-22l-.32.95a32.4,32.4,0,0,0-41.55,21.37Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M149.21,104.22l-1-.28a33.38,33.38,0,0,1,42.82-22l-.32.95a32.4,32.4,0,0,0-41.55,21.37Z"
          fill="#fff"
          opacity="0.2"
        ></path>
        <path
          d="M211.14,103.79a32.3,32.3,0,0,0-14-17.93l.52-.86a33.35,33.35,0,0,1,14.42,18.49Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M211.14,103.79a32.3,32.3,0,0,0-14-17.93l.52-.86a33.35,33.35,0,0,1,14.42,18.49Z"
          fill="#fff"
          opacity="0.2"
        ></path>
        <circle
          cx="180.24"
          cy="184.34"
          r="25.67"
          transform="translate(-39.43 319.28) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="180.24"
          cy="184.34"
          r="25.67"
          transform="translate(-39.43 319.28) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
        <circle
          cx="180.24"
          cy="255.2"
          r="25.67"
          transform="translate(-108.54 374.45) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="180.24"
          cy="255.2"
          r="25.67"
          transform="translate(-108.54 374.45) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
        <circle
          cx="180.24"
          cy="326.07"
          r="25.67"
          transform="translate(-177.65 429.63) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="180.24"
          cy="326.07"
          r="25.67"
          transform="translate(-177.65 429.63) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
        <circle
          cx="109.38"
          cy="113.47"
          r="25.67"
          transform="translate(-25.5 195) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="109.38"
          cy="113.47"
          r="25.67"
          transform="translate(-25.5 195) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
        <circle
          cx="109.38"
          cy="184.34"
          r="25.67"
          transform="translate(-94.6 250.18) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="109.38"
          cy="184.34"
          r="25.67"
          transform="translate(-94.6 250.18) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
        <circle
          cx="109.38"
          cy="255.2"
          r="25.67"
          transform="translate(-163.71 305.35) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="109.38"
          cy="255.2"
          r="25.67"
          transform="translate(-163.71 305.35) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
        <circle
          cx="109.38"
          cy="326.07"
          r="25.67"
          transform="translate(-232.82 360.52) rotate(-77.21)"
          fill="#E3BD3E"
        ></circle>
        <circle
          cx="109.38"
          cy="326.07"
          r="25.67"
          transform="translate(-232.82 360.52) rotate(-77.21)"
          fill="#fff"
          opacity="0.6000000000000001"
        ></circle>
      </g>
      <g id="freepik--Hand--inject-6">
        <path
          d="M272.2,191.88l-5.39-5.58-5.75,7.42s4.38,4.22,9.59,3Z"
          fill="#9f5b53"
        ></path>
        <polygon
          points="259.4 183.24 256.94 191.02 261.06 193.72 266.81 186.3 259.4 183.24"
          fill="#9f5b53"
        ></polygon>
        <path
          d="M186,183.66a9.68,9.68,0,0,1,13.64-5.5l-6-3.12a9.9,9.9,0,0,1-4.7-12.58,9.7,9.7,0,0,1,13.34-4.72l-6-3.11a9.9,9.9,0,0,1-4.7-12.59A9.69,9.69,0,0,1,205,137.33l-28.49-14.9a9.86,9.86,0,0,1-5-11.77,9.7,9.7,0,0,1,13.65-5.5l60,31.37L239,111.25a10.31,10.31,0,0,1,19.63-6.15l19.68,51.12a19.3,19.3,0,0,0,9.05,10.15l3.43,1.79a4.5,4.5,0,0,1,1.9,6.09l-24,45.85a4.52,4.52,0,0,1-6.09,1.91l-8.42-4.4a19.79,19.79,0,0,0-10.34-2.14,48,48,0,0,1-24.94-5.4l-28-14.64A9.86,9.86,0,0,1,186,183.66Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M264.74,224a6,6,0,0,1-2.78-.68l-8.42-4.4a18.51,18.51,0,0,0-9.56-2,49.52,49.52,0,0,1-25.72-5.56l-28-14.64a11.39,11.39,0,0,1-5.67-13.58,11.13,11.13,0,0,1,6.43-6.8,9.66,9.66,0,0,1,1.25-.42,11.37,11.37,0,0,1-4.66-14.1,11,11,0,0,1,6.53-6.07c.27-.09.54-.18.81-.25a11.36,11.36,0,0,1-4.66-14.1,11,11,0,0,1,6.53-6.06c.25-.09.51-.17.76-.24l-21.76-11.38a11.39,11.39,0,0,1-5.67-13.58,11.2,11.2,0,0,1,15.76-6.35L243,133.67l-5.39-22.07a11.8,11.8,0,0,1,22.48-7l19.68,51.12a17.79,17.79,0,0,0,8.35,9.36l3.42,1.79a6,6,0,0,1,2.54,8.11l-24,45.86A6,6,0,0,1,264.74,224Zm-19.63-10.09a21.21,21.21,0,0,1,9.82,2.35l8.42,4.4a3,3,0,0,0,4.07-1.27l24-45.86a3,3,0,0,0-1.28-4.06l-3.42-1.79A20.72,20.72,0,0,1,277,156.76l-19.69-51.12a8.8,8.8,0,0,0-16.77,5.25l6.18,25.29a1.49,1.49,0,0,1-.53,1.53,1.48,1.48,0,0,1-1.62.15l-60-31.37a8.17,8.17,0,0,0-6.82-.33,8,8,0,0,0-4.71,5,8.38,8.38,0,0,0,4.22,10l28.5,14.9a1.5,1.5,0,0,1-1.39,2.66,8.18,8.18,0,0,0-6.5-.45,8.07,8.07,0,0,0-4.78,4.43,8.39,8.39,0,0,0,4,10.66l6,3.12h0a1.5,1.5,0,0,1-1.39,2.65h0a8.19,8.19,0,0,0-6.49-.45,8.09,8.09,0,0,0-4.78,4.44,8.39,8.39,0,0,0,4,10.65l6,3.12h0a1.5,1.5,0,0,1-1.39,2.66h0a8.21,8.21,0,0,0-6.82-.32,8.06,8.06,0,0,0-4.7,5h0a8.37,8.37,0,0,0,4.22,10l28,14.64A46.62,46.62,0,0,0,243.81,214C244.25,214,244.68,213.93,245.11,213.93ZM186,183.66h0Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M207.13,183.57a1.48,1.48,0,0,1-.7-.17L199,179.49a1.5,1.5,0,1,1,1.39-2.66l7.47,3.91a1.5,1.5,0,0,1-.69,2.83Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M209.81,163.15a1.45,1.45,0,0,1-.7-.17l-7.47-3.91a1.5,1.5,0,1,1,1.39-2.65l7.47,3.9a1.5,1.5,0,0,1-.69,2.83Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M212.48,142.74a1.56,1.56,0,0,1-.69-.17l-7.47-3.91a1.5,1.5,0,1,1,1.39-2.66l7.47,3.91a1.5,1.5,0,0,1-.7,2.83Z"
          fill="#E3BD3E"
        ></path>
        <path
          d="M264.74,224a6,6,0,0,1-2.78-.68l-8.42-4.4a18.51,18.51,0,0,0-9.56-2,49.52,49.52,0,0,1-25.72-5.56l-28-14.64a11.39,11.39,0,0,1-5.67-13.58,11.13,11.13,0,0,1,6.43-6.8,9.66,9.66,0,0,1,1.25-.42,11.37,11.37,0,0,1-4.66-14.1,11,11,0,0,1,6.53-6.07c.27-.09.54-.18.81-.25a11.36,11.36,0,0,1-4.66-14.1,11,11,0,0,1,6.53-6.06c.25-.09.51-.17.76-.24l-21.76-11.38a11.39,11.39,0,0,1-5.67-13.58,11.2,11.2,0,0,1,15.76-6.35L243,133.67l-5.39-22.07a11.8,11.8,0,0,1,22.48-7l19.68,51.12a17.79,17.79,0,0,0,8.35,9.36l3.42,1.79a6,6,0,0,1,2.54,8.11l-24,45.86A6,6,0,0,1,264.74,224Zm-19.63-10.09a21.21,21.21,0,0,1,9.82,2.35l8.42,4.4a3,3,0,0,0,4.07-1.27l24-45.86a3,3,0,0,0-1.28-4.06l-3.42-1.79A20.72,20.72,0,0,1,277,156.76l-19.69-51.12a8.8,8.8,0,0,0-16.77,5.25l6.18,25.29a1.49,1.49,0,0,1-.53,1.53,1.48,1.48,0,0,1-1.62.15l-60-31.37a8.17,8.17,0,0,0-6.82-.33,8,8,0,0,0-4.71,5,8.38,8.38,0,0,0,4.22,10l28.5,14.9a1.5,1.5,0,0,1-1.39,2.66,8.18,8.18,0,0,0-6.5-.45,8.07,8.07,0,0,0-4.78,4.43,8.39,8.39,0,0,0,4,10.66l6,3.12h0a1.5,1.5,0,0,1-1.39,2.65h0a8.19,8.19,0,0,0-6.49-.45,8.09,8.09,0,0,0-4.78,4.44,8.39,8.39,0,0,0,4,10.65l6,3.12h0a1.5,1.5,0,0,1-1.39,2.66h0a8.21,8.21,0,0,0-6.82-.32,8.06,8.06,0,0,0-4.7,5h0a8.37,8.37,0,0,0,4.22,10l28,14.64A46.62,46.62,0,0,0,243.81,214C244.25,214,244.68,213.93,245.11,213.93ZM186,183.66h0Z"
          opacity="0.30000000000000004"
        ></path>
      </g>
    </svg>
  );
};

export default SelectOptMsg;
